export default __webpack_public_path__ + "static/media/sticker-C.72d006b8.png";